import { useProfile } from '@modules/profile/loader';
import { Profile } from '@modules/profile/model';
import { Predicate } from 'effect';

export function useProfilePredicate(predicate: Predicate.Predicate<Profile>) {
  return predicate(useProfile());
}
